import React from 'react';
import { Flex, Box, xcss, media, type Breakpoint } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { ff } from '@atlassian/jira-feature-flagging';
import {
	PAGE_TOP_BAR_ACTIONS_TEST_ID,
	PAGE_TOP_BAR_CONTENT_TEST_ID,
	PAGE_TOP_BAR_TEST_ID,
} from '../constants';

// Target state: PageHeaderProps to be replaced with Props below when 'sea-2744-jsw-tabs-nav' is cleaned up
type PageHeaderProps = React.ComponentProps<typeof PageHeader> & {
	wrappingBreakpoint?: Breakpoint;
};
type Props = Pick<
	PageHeaderProps,
	// The content to go on the left side of the PageTopBar
	| 'bottomBar'
	// The content to go on the right side of the PageTopBar, usually a ButtonGroup
	| 'actions'
	// Specify the Breakpoint at which the PageTopBar should wrap the bottomBar and actions. Requires 'sea-2744-jsw-tabs-nav' feature flag.
	| 'wrappingBreakpoint'
>;

const SporkPageTopBar = ({ bottomBar, actions, wrappingBreakpoint = 'md' }: Props) => (
	<Flex
		testId={PAGE_TOP_BAR_TEST_ID}
		gap="space.300"
		xcss={[
			wrapperStyles,
			xcss({
				// @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type Breakpoint can't be used to index type
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				[media.below[wrappingBreakpoint as Breakpoint]]: {
					flexWrap: 'wrap',
				},
			}),
		]}
	>
		{bottomBar && <Box testId={PAGE_TOP_BAR_CONTENT_TEST_ID}>{bottomBar}</Box>}
		{actions && (
			<Box testId={PAGE_TOP_BAR_ACTIONS_TEST_ID} xcss={actionsBoxStyles}>
				{actions}
			</Box>
		)}
	</Flex>
);

export const PageTopBar = (props: PageHeaderProps) =>
	ff('sea-2744-jsw-tabs-nav') ? (
		<SporkPageTopBar
			bottomBar={props.bottomBar}
			actions={props.actions}
			wrappingBreakpoint={props.wrappingBreakpoint}
		/>
	) : (
		<PageHeader {...props} />
	);

const wrapperStyles = xcss({
	flexWrap: 'nowrap',
	paddingTop: `${token('space.150', '1rem')}`,
	paddingBottom: `${token('space.150', '1rem')}`,
});

const actionsBoxStyles = xcss({
	flexShrink: 0,
	marginLeft: 'auto',
});
